module.exports = __webpack_public_path__ + "resource/img/image017Dark.39ff9730.png";